import { SubmitFunction, ValidateFunction } from 'components/BaseForm/types';
import { useApi } from 'hooks/ApiStoreContext';
import { useSubmitReferentielForm } from 'hooks/referentiels/useSubmitReferentielForm';
import { useValidateReferentielForm } from 'hooks/referentiels/useValidateReferentielForm';

import { GenreSimplifieFormField, GenreSimplifieFormValue } from '../types';
import { buildDto } from '../utils';

export function useModalCreate(
  refreshDashboard: () => void,
  close: () => void,
): SubmitFunction<GenreSimplifieFormValue> &
  ValidateFunction<GenreSimplifieFormValue, GenreSimplifieFormField> {
  const { AdminFonctionnelControllerApi } = useApi();
  const { submit, inProgress } = useSubmitReferentielForm(
    refreshDashboard,
    close,
    (values: GenreSimplifieFormValue) =>
      AdminFonctionnelControllerApi.createGenreSimplifieUsingPOST(
        buildDto(values),
      ),
  );
  const { validate } = useValidateReferentielForm(
    (field: GenreSimplifieFormField, values: GenreSimplifieFormValue) =>
      AdminFonctionnelControllerApi.validateCreateGenreSimplifieFieldUsingPOST(
        field,
        buildDto(values),
      ),
    response => response.genreSimplifieViolationsDto ?? [],
  );

  return {
    submit,
    inProgress,
    validate,
  };
}
